// Une fiche client corrigée (adresses, temps supplémentaire de chargement) est appliquée par le Dispatch
// sur le camion de ses commandes, même une journée passée : le camion garde ses autres valeurs du dispatch.
// Une journée clôturée est seulement consultée. Un conflit déjà expliqué sous la commande attend le répartiteur.
const FICHE_FIELDS = new Set(["address", "loading_address", "meunerie_loading_extra_minutes"]);

export function pendingAddressOrderIds(sourceChanges, resultsData = null, dispatchDate = "") {
  const day = resultsData?.dispatch_days?.find?.((item) => item?.dispatch_date === dispatchDate);
  if (day?.is_closed || ["closed", "archived"].includes(day?.dispatch_day_state)) return [];
  const details = sourceChanges?.details?.modified_same_date;
  return [...new Set((Array.isArray(details) ? details : []).filter((detail) => {
    const fields = (detail?.changed_fields || []).filter((field) => detail.field_changes?.[field]?.category !== "metadata");
    return fields.length > 0 && fields.every((field) => FICHE_FIELDS.has(field))
      && detail.removal_eligible !== false && !detail.application_feedback;
  }).map((detail) => detail.order_id).filter(Boolean))].sort();
}

export function addressRefreshToast(result) {
  const conflicts = result?.conflicts || [];
  if (result?.error || (result?.outcome === "blocked" && !conflicts.length)) {
    return { type: "warning", title: "Fiches clients à appliquer dans Mise à jour", duration: 9000,
      message: `Changements non appliqués : ${result.error?.message || result.message || "le calcul n’a pas pu être terminé."} `
        + "Les commandes restent dans « Cmd modifiées vers Suspendues »." };
  }
  const trucks = result?.applied_truck_labels || [];
  const messages = trucks.length ? [`Changements de fiche client appliqués sur ${trucks.join(", ")}.`]
    : result?.applied_order_ids?.length ? ["Changements de fiche client appliqués dans Suspendues."] : [];
  conflicts.forEach((conflict) => messages.push(`${conflict.truck_label} : ${conflict.message}`));
  if (!messages.length) return null;
  return conflicts.length
    ? { type: "warning", title: "Fiches clients à vérifier dans Mise à jour", duration: 12000,
      message: `${messages.join(" ")} Voir « Cmd modifiées vers Suspendues ».` }
    : { type: "success", title: "Dispatch actualisé", duration: 8000, message: messages.join(" ") };
}
